var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main',{staticClass:"qrs-typography",attrs:{"id":"main"}},[_c('div',{staticClass:"app__container",attrs:{"id":"app-container"}},[_c('router-view',{key:_vm.$route.fullPath})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }